<template>
    <ns-modal
        v-model="dialog"
        :fullscreen="fullScreen"
        :title="txc.edit_privacy_preferences"
        @input="closeDialog"
    >
        <server-error v-if="!!dialogError" :error="dialogError" />

        <v-checkbox
            v-if="isDistributor && marketLoggedIn !== 'JP' && false"
            v-model="sponsorSearch"
        >
            <template v-slot:label>{{ txc.sponsor_search }}</template>
        </v-checkbox>
        <v-checkbox
            v-if="(isRetailCustomer || isMember) && marketLoggedIn !== 'JP'"
            v-model="firstUpLine"
        >
            <template v-slot:label>{{ txc.retail_privacy_label }}</template>
        </v-checkbox>
        <v-checkbox
            v-model="firstUpLine"
            v-if="isDistributor || marketLoggedIn == 'JP'"
        >
            <template v-slot:label>{{ txc.upline_description }}</template>
        </v-checkbox>
        <v-radio-group class="ml-4" v-model="privacyType">
            <v-radio v-if="firstUpLine" :label="txc.name_only_label" :value="1" />
            <v-radio v-if="firstUpLine" :label="txc.full_info_label" :value="0" />
        </v-radio-group>
        <p
            v-if="isRetailCustomer || isMember"
            v-html="txc.retail_privacy_description"
        ></p>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        @click="updatePrivacy"
                        :disabled="!privacyPrefChanged"
                    >
                        {{ sharedStrings.generic.save }}
                    </button>
                </v-flex>
                <v-spacer />
                <v-flex xs12>
                    <button
                        flat
                        block
                        outline
                        class="secondary-hit fluid"
                        @click="closeDialog"
                    >
                        {{ sharedStrings.generic.cancel }}
                    </button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import { ProfileService } from '@nuskin/ns-account'
import { mapGetters, mapActions } from 'vuex'

import profileUtils from '../../repositories/profileUtils'

import { NsModal } from '@nuskin/design-components'
import ServerError from '../ServerError'
import editPrivacyPreferenceDialog from '../../helpers/forms/editPrivacyPreferenceDialog'

export default {
    components: {
        NsModal,
        ServerError
    },
    data() {
        return {
            dialog: true,
            dialogError: null,
            firstUpLine: '',
            sponsorSearch: '',
            retailPrivacy: '',
            privacyType: 0
        }
    },
    computed: {
        ...mapGetters({
            marketLoggedIn: 'marketLoggedIn',
            getPrivacy: 'getPrivacy',
            fullScreen: 'mobileView',
            txc: 'translationsPrivacy',
            sharedStrings: 'sharedStrings',
            isDistributor: 'isDistributor',
            isRetailCustomer: 'isRetailCustomer',
            isMember: 'isMember',
            visibleInSponsorSearch: 'visibleInSponsorSearch',
            marketConfig: 'marketConfig'
        }),
        privacyPrefChanged() {
            return ((this.firstUpLine !== (this.getPrivacy === 2 ? false : true)) || 
                (this.privacyType !== (this.getPrivacy === 2 ? 0 : this.getPrivacy))) // || this.sponsorSearch !== this.visibleInSponsorSearch
        }
    },
    methods: {
        ...mapActions(['setAccount', 'setPrivacy']),
        closeDialog() {
            this.$emit('closeDialog')
            this.dialogError = null
        },
        updatePrivacy() {
            // if (this.marketLoggedIn !== 'JP' && this.isDistributor) {
            //    // editPrivacyPreferenceDialog.callNonJapanPrivacy(
            //        // this,
            //        // ProfileService,
            //        // profileUtils
            //    // )
            // } else {
            //    // editPrivacyPreferenceDialog.callPrivacy(this, ProfileService)
            // }
            editPrivacyPreferenceDialog.callPrivacy(this, ProfileService)
        }
    },
    created() {
        if (this.marketLoggedIn !== 'JP' && this.isDistributor) {
            this.sponsorSearch = this.visibleInSponsorSearch
        }

        this.firstUpLine = this.getPrivacy === 2 ? false : true

        this.privacyType = this.getPrivacy === 2 ? 0 : this.getPrivacy

        profileUtils.publishAnalytics(
            this.$analytics.category.privacy,
            'privacy_preferences_dialog',
            'opened'
        )
    },
    destroyed() {
        profileUtils.publishAnalytics(
            this.$analytics.category.privacy,
            'privacy_preferences_dialog',
            'closed'
        )
    }
}
</script>

<style scoped>

</style>
